import {Languages} from '@shared/languages';
import {
  footerFallbackEn,
  footerFallbackRU,
  footerFallbackZh,
} from '@strapi/endpoints/Footer';
import {
  headerFallbackEn,
  headerFallbackRu,
  headerFallbackZh,
} from '@strapi/endpoints/Header/header.fallback';

export const getHeaderLocaleFallback = (locale?: Languages) => {
  if (!locale) return headerFallbackRu;
  switch (locale) {
    case 'en':
      return headerFallbackEn;
    case 'zh':
      return headerFallbackZh;
    default:
      return headerFallbackRu;
  }
};

export const getFooterLocaleFallback = (locale?: Languages) => {
  if (!locale) return footerFallbackRU;
  switch (locale) {
    case 'en':
      return footerFallbackEn;
    case 'zh':
      return footerFallbackZh;
    default:
      return footerFallbackRU;
  }
};
